import { MODAL_ID_DEFAULT } from '../../constants/common'
import { MINIMIZED_MODAL_KEY } from '../Modal'

export const PROVIDER_ACTION_ARCHIVE = 'archive'

export const PROVIDER_ACTION_RESTORE = 'restore'

export const PROVIDER_ACTION_ARCHIVE_MASS = 'archive_mass'

export const PROVIDER_ACTION_RESTORE_MASS = 'restore_mass'

export const PROVIDER_ACTION_MASS_EMAIL = 'mass_mailing'

export const PROVIDER_ACTION_EDIT_BUILDINGS_AND_CATEGORIES =
  'edit_buildings_and_categories'

export const PROVIDER_ACTION_EDIT_BUILDINGS_AND_CATEGORIES_MASS =
  'edit_buildings_and_categories_mass'

export const PROVIDER_MASS_ACTION_NAMES = {
  [PROVIDER_ACTION_ARCHIVE]: 'archive',
  [PROVIDER_ACTION_ARCHIVE_MASS]: 'archive',
  [PROVIDER_ACTION_EDIT_BUILDINGS_AND_CATEGORIES]: 'update_mapping',
  [PROVIDER_ACTION_EDIT_BUILDINGS_AND_CATEGORIES_MASS]: 'update_mapping',
  [PROVIDER_ACTION_RESTORE]: 'restore',
  [PROVIDER_ACTION_RESTORE_MASS]: 'restore',
}

export const PROVIDER_TABLE_MODALS_CONFIG = {
  setEmailFormModal: {
    closer: 'closeEmailFormModal',
    id: MINIMIZED_MODAL_KEY.EMAIL_FORM,
  },
  setModal: { closer: 'closeModal', id: MODAL_ID_DEFAULT },
}
